import { stringDuckCreator } from '@atc/modular-redux';

export default stringDuckCreator({
    store: 'currentPageName',
    initialState: null,
});
